import LxSaveButton from '@src/components/saveButton/LxSaveButton'

export const GeneratePdfReport = () => {
  const handleExportToPdf = () => {
    window.print()
  }

  return <LxSaveButton label='Export to PDF' onSubmit={handleExportToPdf} classNames='lxActionButton,ignoreOnPrint,lxActionButtonDefaultSize' />
}
